import { updateJwtToken } from 'modules/session/actions/updateJwtToken';


export const onAuthUpdates = ({ err, data }) => (dispatch) => {
  if (err) throw new Error(err);

  if (data && data.webSocketAuth.message === 'EXPIRED_JWT') {
    return dispatch(updateJwtToken());
  }
};
